import { Moment } from 'moment';
import { Certificate } from '../../../common/certificates/models/Certificate';
import { PublicKey } from '../../../common/certificates/models/valueObjects/PublicKey';

export class ReportCertificate extends Certificate {
  constructor(
    id: number,
    subject: string,
    issuer: string,
    publickey: PublicKey,
    fingerprint: string | null,
    expiryDate: Moment | null,
    digestAlgorithm: string | null,
    private readonly reportId: number,
    private readonly venafiGuid: string | null,
    private readonly reportVenafiLastUpdate: string | null
  ) {
    super(id, subject, issuer, publickey, fingerprint, expiryDate, digestAlgorithm);
  }

  getReportId() {
    return this.reportId;
  }

  getVenafiGuid() {
    return this.venafiGuid;
  }

  getVenafiLastUpdate() {
    return this.reportVenafiLastUpdate;
  }
}
